import styled, {css} from 'styled-components'

export const StyledDashboardCard = styled.div(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding: ${spacing * 3}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 1}px;
        min-width: 200px;
        justify-content: space-between;
    `
)
